const add_ids_to_url = (ids, url) => {
    const urlObj = new URL(url, window.location.origin);

    const searchParams = urlObj.searchParams;

    searchParams.delete('ids');
    searchParams.append('ids', ids.join('|'));

    return urlObj.toString();
};

export default add_ids_to_url;
